import api from '@/api/candidateStatus'

const state = {

}

const actions = {
  getCandidateStatusList (context, params) {
    return api.getCandidateStatusList(params)
  },
  getStatusChangeReasonList (context, params) {
    return api.getStatusChangeReasonList(params)
  },
  getCandidateStatusChangeCauseList (context, params) {
    return api.getCandidateStatusChangeCauseList(params)
  },
  getCandidateStatusChangeCauseByCauseId (context, { causeId, params }) {
    return api.getCandidateStatusChangeCauseByCauseId(causeId, params)
  },
  moveCandidateStatusChangeCause (context, data) {
    return api.moveCandidateStatusChangeCause(data)
  },
  saveCandidateStatusChangeCause (context, data) {
    return api.saveCandidateStatusChangeCause(data)
  },
  updateCandidateStatusChangeCause (context, { causeId, data }) {
    return api.updateCandidateStatusChangeCause(causeId, data)
  },
  deleteCandidateStatusChangeCause (context, { causeId, data }) {
    return api.deleteCandidateStatusChangeCause(causeId, data)
  },
  getAllCandidateStatusList (context, params) {
    return api.getAllCandidateStatusList(params)
  },
  getCandidateStatusInfoByStatusKey (context, params) {
    return api.getCandidateStatusInfoByStatusKey(params)
  },
  createCandidateStatus (context, params) {
    return api.createCandidateStatus(params)
  },
  updateCandidateStatus (context, params) {
    return api.updateCandidateStatus(params)
  },
  updateCandidateStatusOrder (context, params) {
    return api.updateCandidateStatusOrder(params)
  },
  getCompanyBingingCandidateStatusList (context, companyId) {
    return api.getCompanyBingingCandidateStatusList(companyId)
  },
  updateCompanyBingingCandidateStatus (context, { companyId, data }) {
    return api.updateCompanyBingingCandidateStatus(companyId, data)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
